export default "__VITE_ASSET__BCiIArVi__"